import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
var VueScrollTo = require('vue-scrollto');
import VueTranslate from 'vue-translate-plugin';
import store from './store'
import locales from './locales'
import VCalendar from 'v-calendar'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(VueTranslate)
Vue.locales(locales)
Vue.use(VueScrollTo, { duration: 1000 })
Vue.use(VCalendar)

Vue.use(VueMeta)


new Vue({
  name: 'Syndicat Intercommunal à Vocation Ecologique',
  render: h => h(App),
  store
}).$mount('#app')



